import React from "react";
import Stack from "@mui/material/Stack";
import { Typography, Paper, Link } from "@mui/material";
import { getStyled } from "@sf-core";
import { useTranslation, Trans } from "react-i18next";
import { ReactComponent as EyLogo } from "./images/logo.svg";
import env from "../../env";

const { styled } = getStyled();

const Item = styled(Paper)(({ theme }) => ({
  textAlign: "center",
}));

const LinkText = (props) => (
  <Link variant="blue" href={props.href || null} to={props.to || null}>
    {props.text}
  </Link>
);

const TryAgainText = (props) => (
  <Link
    sx={{ cursor: "pointer" }}
    variant="blue"
    onClick={() => {
      localStorage.clear();
      location.href = "/";
    }}
  >
    {props.text}
  </Link>
);

const UnAuthorizedScreen = () => {
  const { t } = useTranslation();

  return (
    <Stack spacing={2} sx={{ width: "90%" }}>
      <Item elevation={0}>
        <EyLogo />
      </Item>
      <Item elevation={0}>
        <Typography
          component="h1"
          sx={{
            color: "#3A3A4A",
            fontSize: 28,
            fontWeight: 400,
          }}
        >
          {t("signinScreen.unauthorized.title")}
        </Typography>
      </Item>
      <Item elevation={0}>
        <Typography
          component="h2"
          sx={{
            color: "#3A3A4A",
            fontSize: 20,
            fontWeight: 400,
          }}
        >
          {t("signinScreen.unauthorized.caption")}
        </Typography>
      </Item>

      <Item elevation={0}>
        <Typography
          component="p"
          sx={{
            fontSize: 14,
          }}
        >
          <Trans
            i18nKey="signinScreen.unauthorized.support"
            t={t}
            values={{ supportMail: env.REACT_APP_SUPPORT_EMAIL }}
            components={{ link: <LinkText /> }}
          />
        </Typography>
      </Item>
      <Item elevation={0}>
        <Typography
          component="p"
          sx={{
            fontSize: 12,
          }}
        >
          <Trans
            i18nKey="signinScreen.unauthorized.tryAgain"
            t={t}
            components={{ link: <TryAgainText /> }}
          />
        </Typography>
      </Item>
    </Stack>
  );
};

export default UnAuthorizedScreen;
